export const downloadByUrl = async (url: string, filename: string) => {
  const a = document.createElement('a');

  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();

  return new Promise(resolve => {
    setTimeout(() => {
      document.body.removeChild(a);
      resolve(true);
    }, 0);
  });
};

export async function download(
  data: unknown,
  name = 'Новый файл',
  type = 'application/octet-stream',
  ntAddXlsx = true
) {
  if (!window) {
    console.warn('Error! window is not present.');
    return;
  }

  const file = new Blob([data], { type });
  const filename = ntAddXlsx ? name + '.xlsx' : name;

  if (window.navigator.msSaveOrOpenBlob) {
    return window.navigator.msSaveOrOpenBlob(file, filename);
  }

  const url = URL.createObjectURL(file);
  await downloadByUrl(url, filename);
  window.URL.revokeObjectURL(url);
}
